import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { CategoriesWithProduct } from "app/_models/categories";
import { CrudCategoryService } from "app/_services/MasterCrudOps/crudcategory.service";
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { AddCategoryComponent } from "./add-category/add-category.component";
import { EditCategoryComponent } from "./edit-category/edit-category.component";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { UserModel } from "app/_models/user-model";
declare const swal: any;

@Component({
  selector: "app-category-master",
  templateUrl: "./category-master.component.html"
})
export class CategoryMasterComponent implements OnInit, AfterViewInit {
  
  currentUser: UserModel;
  isAdminGroupUser: boolean = false;
  categories: CategoriesWithProduct[];
  totalresultDetails: CategoriesWithProduct[];
  displayedColumns: string[] = [
    "icon",
    "productName",
    "categoryName",
    "description",
    "edit",
    "delete",
  ];
  dataSource = new MatTableDataSource<CategoriesWithProduct>([]);
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  editCategory: CategoriesWithProduct;
  pageEvent: PageEvent;

  constructor(
    public datepipe: DatePipe,
    private readonly crudCategoryService: CrudCategoryService,
    private readonly _liveAnnouncer: LiveAnnouncer,
    private readonly matDialog: MatDialog
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit() {
    this.isLoaderResult = true;
    this.dataSource = null; 
    this.categories = null;
    this.pageSize  = 25;
    this.getAllCategoriesWithProducts(1, this.pageSize, false);
    this.isLoaderResult = false;
  }
  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  /** Announce the change in sort state for assistive technology. */
  announceCategorySort(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  onAddCategoryClick() {
    const dialogRef = this.matDialog.open(AddCategoryComponent, {
      width: "800px",
      disableClose: false,
      data: {pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status )
      {
        this.getAllCategoriesWithProducts(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
    
  }

  onDeleteCategory(e, element) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteCategory(e, element);
      }
    });
  }

  deleteCategory(e, element): void {
    this.isLoaderResult = true;
    this.crudCategoryService
      .deleteCategory(element.categoryId)
      .subscribe((data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message + "\n" + data.additionalMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.getAllCategoriesWithProducts((this.paginator.pageIndex+1), this.paginator.pageSize, false);
        }
      });
    this.isLoaderResult = false;
  }

  onEditCategory(e, element): void {
    this.editCategory = JSON.parse(JSON.stringify(element)) ;//deep copy
    const dialogRef = this.matDialog.open(EditCategoryComponent, {
      width: "800px",
      disableClose: true,
     data: {  category:this.editCategory,   pageNumber:(this.paginator.pageIndex +1 ),  pageSize:this.paginator.pageSize}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllCategoriesWithProducts(result.pageNumber, result.pageSize,false);
        setTimeout(() => {
        }, 1500);
      }
    });
  }
 

  getAllCategoriesWithProducts(pageNumber: number, currPageSize: number, hasDownloadAllData:boolean) {
    let model = {
      currentPage: pageNumber,
      pageSize: currPageSize,
      downloadAllData: hasDownloadAllData,
      stateId:0
    } ;

    this.crudCategoryService
      .getPagedAllCategoriesWithProducts(model)
      .subscribe((data) => {
        this.isLoaderResult = false;
        if (!data.didError) {
          this.categories = data.model;
          this.dataSource = new MatTableDataSource<CategoriesWithProduct>(
            this.categories
          );
          this.totalRows = data.totalRecords;
          this.resultLength = this.categories.length;
        } else {
          this.categories = data.model;
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      },
      (error) => {
        this.isLoaderResult = false;
        swal({
          title: "",
          text: "Somthing went wrong. Please contact admin",
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  onDownloadCategoriesClick()
  {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        let model = {
          currentPage:0,
          pageSize:0,
          downloadAllData:true,
          stateId: 0
        };
       this.crudCategoryService
           .getPagedAllCategoriesWithProducts(model)
           .subscribe(
                    (results) => {
          this.isLoaderResult = false;
          if (!results.didError) {
            this.totalresultDetails = results.model;
            const workSheet = XLSX.utils.json_to_sheet(
              this.totalresultDetails.map((item) => {
                return {
                  Product: item.productName,
                  Category:item.categoryName,
                  Description: item.description,
                };
              })
            );
            const workBook: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
            let fileName =
              "Categories_" +
              this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
              ".xlsx";
            XLSX.writeFile(workBook, fileName);
          } else {
            this.isLoaderResult = false;
            swal({
              title: "",
              text: results.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        },
        (error) => {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
      }
    });
  }
 
 applyCategoryFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAllCategoriesWithProducts((this.paginator.pageIndex+1), this.paginator.pageSize, false);
  }
  
}
